import { Service } from "../global/types";
import React from "react";
import { Flex, Link, Image, Text, useColorModeValue } from "@chakra-ui/react";

export default function ServicesCard(props: { inputService: Service }): JSX.Element {
  const { title, url, imgUrl, description } = props.inputService;
  const borderColor = useColorModeValue("primary", "light");

  return (
    <Flex
      direction="column"
      border="2px"
      borderColor={borderColor}
      borderRadius="20"
      mb="1rem"
      overflow="hidden"
      width="100%"
    >
      {/* Ολόκληρη η κάρτα γίνεται clickable */}
      <Link
        href={url}
        isExternal
        _hover={{ textDecoration: "none" }}
        width="100%"
      >
        <Flex
          direction="row"
          alignItems="center"
          gap={3}
          p={3}
        >
          {/* Εικόνα */}
          <Image
            src={imgUrl}
            width="60px"
            height="60px"
            borderRadius="full"
          />

          {/* Τίτλος */}
          <Flex
            flexGrow={1}
            justifyContent="center"
          >
            <Text
              fontWeight="bold"
              fontSize={{ sm: 14, md: 16, lg: 18 }}
            >
              {title}
            </Text>
          </Flex>
        </Flex>

        {/* Περιγραφή (τώρα clickable) */}
        {description && (
          <Text
            px={3}
            pb={3}
            mt="-1"
            color="gray.400"
            fontSize={{ base: "sm", md: "sm", lg: "md" }}
            whiteSpace="pre-line"
            textAlign="left"
          >
            {description}
          </Text>
        )}
      </Link>
    </Flex>
  );
}